import { useState, useEffect } from 'react'
import useFeatureFlags from './useFeatureFlags'

export default function useUserInfo() {
    const urlSectionName = getSectionNameFromUrl()
    const urlThemeSetting = getParameterFromUrl('background')
        ? getParameterFromUrl('background')
        : 'light'

    const [userInfo, setUserInfo] = useState([])
    const {
        flags,
        loading: flagsLoading,
        experimentalEnabled,
    } = useFeatureFlags()

    useEffect(() => {
        const getUserInfo = async () => {
            const userInfoResponse = await fetch('/react/user').then(
                response => {
                    return response.json()
                }
            )

            switch (urlSectionName) {
                case userInfoResponse.username:
                case 'apps':
                case 'subscription':
                case 'api-access':
                case 'import':
                case 'imports':
                case 'settings':
                    setUserInfo({
                        ...userInfoResponse,
                        isPublic: false,
                        flags,
                        experimentalEnabled,
                        flagsLoading,
                    })
                    break
                default:
                    setUserInfo({
                        username: urlSectionName,
                        theme: urlThemeSetting,
                        isPublic: isLookingAtPublicGraph(
                            userInfoResponse.username,
                            urlSectionName
                        ),
                        flags,
                        experimentalEnabled,
                        flagsLoading,
                    })
            }
        }
        getUserInfo().catch(
            setUserInfo({
                username: urlSectionName,
                theme: urlThemeSetting,
                isPublic: true,
                flags,
                experimentalEnabled,
                flagsLoading,
            })
        )
    }, [flags, flagsLoading, experimentalEnabled])

    return userInfo
}

const isLookingAtPublicGraph = (username, urlSectionName) => {
    // if the username is not part of the url section name
    // then looking at a graph of another user
    return !username || (username && urlSectionName !== username)
}

const getSectionNameFromUrl = () => {
    if (!window || !window.location) return null
    return decodeURIComponent(
        window.location.pathname.replace(/^\/([^\/]*).*$/, '$1')
    )
}

const getParameterFromUrl = parameter => {
    if (!window || !window.location) return null

    const urlParameters = new URLSearchParams(window.location.search)
    return urlParameters.get(parameter)
}
